module.exports = __webpack_public_path__ + "img/android_it.fb7d4190.png";